import Api from "@/helpers/api.js";

export default {
	addBreak({commit}, item) {
		return new Promise((resolve, reject) => {
			Api.post("/breaks", item)
				.then((response) => {
					commit("ADD_BREAK", Object.assign(item, {id: response.data.id}));
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchDataListItems({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/breaks")
				.then((res) => {
					commit("SET_BREAKS", res.data);
					resolve(res);
				})
				.catch((err) => {
					console.error(err);
					reject(err);
				});
		});
	},
	updateItem({commit}, item) {
		return new Promise((resolve, reject) => {
			Api.put(`/breaks/${item.id}`, item.params)
				.then((response) => {
					commit("UPDATE_BREAK", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	removeItem({commit}, itemId) {
		return new Promise((resolve, reject) => {
			Api.delete(`/breaks/${itemId}`)
				.then((response) => {
					commit("REMOVE_BREAK", itemId);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	findById({commit}, itemId) {
		return new Promise((resolve, reject) => {
			Api.get(`/breaks/${itemId}`)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	findBreaksFilter({commit}, data) {
		return new Promise((resolve, reject) => {
			const payload = {
				page: data.page || 1,
				quantity: data.quantity || 1000000,
				fields: ["id", "name", "description", "cron", "duration", "vehicle_id"],
				id: data.id || [],
				name: data.name || [],
				description: data.description || [],
				cron: data.cron || [],
				duration: data.duration || [],
				vehicle_id: data.vehicle_id || [],
				match_filter: data.match_filter,
				order_by: data.order_by || ["id"],
				sort: data.sort || "asc",
			};
			Api.post("/breaks/filter", payload)
				.then((res) => {
					if (data.assign) {
						commit("SET_ASSIGNED_BREAK", res.data.records);
					} else {
						commit("SET_BREAKS_FILTER", res.data.records);
					}
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
};
